// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"17":"ViewSale","94":"Login","220":"create-debtor","351":"float","472":"settings","693":"salesRecords","930":"setup"}[chunkId] + "." + {"17":"4c3fc553","94":"914c4420","220":"51dc7394","351":"86555ae4","472":"4e77bff5","693":"f9815d0b","930":"3c98f064"}[chunkId] + ".css";
};